export default __webpack_public_path__ + "locales/fr/RoomLogoCover.json?hash=5df06c36ab4b33735a6cd122f1edc263";